<template>
    <basic-container>
        <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="老人身份证附件模板上传
" prop="nursinghomeId">
                <vUpload
              :disabled="model=='view'"
                :message="'提示：上传文件不大于5MB，数量最多1张'"
                :types="['doc', 'docx', 'ppt', 'pptx', 'txt', 'xlsx', 'xls', 'pdf', 'jpg', 'png']"
                :max="5242880"
                :limit="1"
                :fileList.sync="form.idCardAttachmentTemplateFileUrlList"
              ></vUpload>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="老人医保卡附件模板上传" prop="serviceType">
                <vUpload
              :disabled="model=='view'"
                :message="'提示：上传文件不大于5MB，数量最多1张'"
                :types="['doc', 'docx', 'ppt', 'pptx', 'txt', 'xlsx', 'xls', 'pdf', 'jpg', 'png']"
                :max="5242880"
                :limit="1"
                :fileList.sync="form.healthInsuranceCardAttachmentTemplateFileUrlList"
              ></vUpload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="老人能力报告模板上传" prop="serviceType">
                <vUpload
              :disabled="model=='view'"
                :message="'提示：上传文件不大于5MB，数量最多1张'"
                :types="['doc', 'docx', 'ppt', 'pptx', 'txt', 'xlsx', 'xls', 'pdf', 'jpg', 'png']"
                :max="5242880"
                :limit="1"
                :fileList.sync="form.abilityReportTemplateFileUrlList"
              ></vUpload>
            </el-form-item>
            
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="合同附件模板上传" prop="serviceType">
                <vUpload
              :disabled="model=='view'"
                :message="'提示：上传文件不大于5MB，数量最多1张'"
                :types="['doc', 'docx', 'ppt', 'pptx', 'txt', 'xlsx', 'xls', 'pdf', 'jpg', 'png']"
                :max="5242880"
                :limit="1"
                :fileList.sync="form.contractAttachmentFileUrlList"
              ></vUpload>
            </el-form-item>
            
          </el-col>
         
        </el-row>
      </el-form>
      <div style="    text-align: right;" >
      <el-button v-if="permission.nursingHomeDocument" type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        提交
      </el-button>
      
    </div>
    </basic-container>
  </template>
  <script>

import {documentList,documentUpload} from "../api/document.js";
import vUpload from '../components/mutil-upload.vue';
import { mapGetters } from 'vuex';
  export default {
components:{vUpload},
    data() {
      return {
        form: {
            idCardAttachmentTemplateFileUrlList:[],
            healthInsuranceCardAttachmentTemplateFileUrlList:[],
            abilityReportTemplateFileUrlList: [],
            contractAttachmentFileUrlList:[]
       
      },
      };
    },
    created() {
        this.getList()
      
    },
    computed: {
      ...mapGetters(['permission']),
    permissionList() {
      return {
        submitBtn: this.vaildData(this.permission.nursingHomeDocument, false),
       
      };
    },
    },
    mounted() {

    },
    methods: {
        getList(){
            documentList().then(res=>{
            this.form = res.data
        })
        },
        saveRecord(){
            this.$message.success('上传成功');
            documentUpload(this.form).then(res=>{
                this.getList()
            })
        }
    },
  };
  </script>
  
  <style scoped>
  ::v-deep .avue-crud__right {
    display: flex;
  }
  ::v-deep .el-col-12{
    min-height: 228px;
  }
  /deep/ .el-drawer__body {
    overflow: scroll !important;
  }
  ::v-deep .avue-crud .el-form-item {
    display: block;
  }
  
  .money {
    text-align: right;
  }
  .txtOver {
    display: -webkit-box;
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*隐藏后添加省略号*/
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  </style>
  <style>
  #nursingForm > div > div.el-dialog__body {
    height: calc(100% - 100px);
  }
  </style>
  